export const appArrowLeftMoIcon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.08" cx="20" cy="20" r="20" fill="#4F4F4F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.4 15.4L21 14L15 20L21 26L22.4 24.6L17.8 20L22.4 15.4Z" fill="#4F4F4F"/></svg>`,
    name: 'arrow-left-mo'
};